export default __webpack_public_path__ + "static/logo-white-b19c2877d46bf6842b12407380e2b9d4.png";